import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Stack,
  Button,
  IconButton,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Paper,
  CircularProgress,
  Popover,
  Typography,
  Divider,
  MenuItem,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  FormControl,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputLabel,
  Select,
  TextField,
} from '@mui/material'


import client from '../common/client.js'
import AceEditor from 'react-ace'
import 'brace/ext/searchbox'
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/theme-github'
import toast, { Toaster } from 'react-hot-toast'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import AddIcon from '@mui/icons-material/Add'
import SettingsIcon from '@mui/icons-material/Settings';
import { getSelectedProject } from '../common/common.js'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const IDESketchAndFigma = props => {
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [figmaConnected, setFigmaConnected] = useState(false)
  const [fileId, setFileId] = useState('')

  useEffect(() => {
    update()
  }, [])

  const update = () => {
    client.request_get(`/api/figma/list?project_id=` + getSelectedProject()).then(res => {
      setLoading(false)
      if (res && res.r) {
        setFigmaConnected(true)
      } else {
        setFigmaConnected(false)
      }
    })
  }

  const handleFigma = () => {
    let client_id = 'g1nQbSmvAwjUPxGbWEvadb'
    let callback = encodeURIComponent('http://localhost:6001/#/figma/login/callback')
    let scope = 'files:read'
    let state = 'state'
    let url = `https://www.figma.com/oauth?client_id=${client_id}&redirect_uri=${callback}&scope=${scope}&state=${state}&response_type=code`
    window.location.href = url
  }

  const handleFigmaAddFile = (e) => {
    if (!fileId)
      return

    setLoading(true)
    client.request_post(`/api/figma/upsert`, { file_id: fileId, project_id: getSelectedProject() }).then(res => {
      setLoading(false)
      if (res && res.r) {
        alert('success')
      } else {
        alert('fail')
      }
    })
  }


  return (
    <Box sx={{ width: '100%', height: '100%', textAlign: 'left', }}>
      <Toaster position='bottom-center' reverseOrder={false} />
      <Box spacing={1} p={3} sx={{ height: 'calc(100% - 50px)', }}>

        <Box>
          <Typography variant="h6">
            Sketch
          </Typography>
        </Box>

        <Divider sx={{ marginTop: 2, marginBottom: 2 }} />

        <Box mb={2}>
          <Typography variant="h6">
            Figma Files
          </Typography>
        </Box>
        {!loading &&
          <Box>
            {//!figmaConnected &&
                <Box>
                <Button variant="outlined" color="primary" startIcon={<AddIcon />} onClick={handleFigma}>
                  Figma Account
                </Button>
              </Box>
            }
            <Stack spacing={1} direction={'row'} alignItems={'center'}>
              <TextField label="File ID" variant="outlined" onChange={e => setFileId(e.target.value)} />
              <Box>
                <Button variant="outlined" color="primary" startIcon={loading ? <CircularProgress size={20} /> : <AddIcon />} onClick={handleFigmaAddFile}>
                  Figma File Id
                </Button>
              </Box>
            </Stack>

          </Box>
        }

      </Box>


    </Box>
  )
}

export default IDESketchAndFigma
